import RadioGroup from 'emerald-ui/lib/RadioGroup';
import Radio from 'emerald-ui/lib/Radio';
import populateDocs from './utils/populateDocs';

export default {
  ...populateDocs([{ component: RadioGroup, componentName: 'RadioGroup' }], 'RadioGroup'),
  description:
    'Manages the selection process of a group of Radio components. The component can be uncontrolled or controlled.',
  codeSamples: [
    {
      title: 'Default',
      scope: { Radio, RadioGroup },
      whiteBackground: true,
      code: `<RadioGroup ariaLabel="color" name="color" defaultCheckedId="green">
  <Radio id="red" value="Red" label="Red" />
  <Radio id="green" value="Green" label="Green" />
  <Radio id="blue" value="Blue" label="Blue" />
</RadioGroup>`,
    },
  ],
};
